module.exports = __webpack_public_path__ + "static/media/LA.595f29f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/LA.jpg
// module id = 309
// module chunks = 0